import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

document.addEventListener("DOMContentLoaded", function () {
  const technosSlider = document.getElementById("hero_technos_slider");

  if (technosSlider) {
    const slider = new Splide(technosSlider, {
      type: "loop",
      perPage: 4,
      perMove: 1,
      gap: 0,
      focus: "left",
      pagination: false,
      arrows: false,
      drag: false,
      breakpoints: {
        540: {
          perPage: 3,
          gap: 0,
        },
        768: {
          perPage: 4,
          gap: 0,
        },
      },
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    });
    slider.mount({ AutoScroll });
  }
});
